import Box from "ds/components/Box";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";

import { CellComponentProps } from "../../types";

type RolesListItemDescriptionCellProps = CellComponentProps;

const RolesListItemDescriptionCell = ({ permission }: RolesListItemDescriptionCellProps) => {
  if (!permission.description) {
    return null;
  }

  return (
    <Box direction="row" align="start">
      <ListEntitiesItemDescriptionMultipleLines
        lines={1}
        hasChevronLink
        description={permission.description}
      />
    </Box>
  );
};

export default RolesListItemDescriptionCell;
